import {
  MaterialComponentCategory,
  type MaterialComponentValue,
  type MaterialProductComponentValue,
  MaterialProductValueType,
} from 'api';
import { MaterialComponentValueList, QualityReportLink } from 'features';
import { getCountryNameByCountryAbbr } from 'form';
import { Link } from 'react-router-dom';
import { Stack, Typography, TypographyIcon } from 'ui';
import { Inventory2Outlined, PublicOutlined } from 'ui/icons';

import { useMatchedSiteMaterialItem } from '../../contexts/MatchedSiteMaterialItemContext';
import { filterMaterialComponentsByCategory } from '../../utils/filterMaterialComponentsByCategory/filterMaterialComponentsByCategory';
import { getAvailableQualityDataForMaterialComponents } from '../../utils/getAvailableQualityDataForMaterialComponents/getAvailableQualityDataForMaterialComponents';
import { MatchedSiteMaterialDetailsSectionTitle } from '../MatchedSiteMaterialDemandSignalItem/styles';
import { QualityDataList } from '../QualityDataList/QualityDataList';

export const SiteMaterialOverview = ({ variant = 'default' }: { variant?: 'default' | 'muted' }) => {
  const { siteMaterial, demandSignal } = useMatchedSiteMaterialItem();
  const { id, material_spec, grade, site, material_product, public_id, quality_data } = siteMaterial;
  const textVariant = variant === 'default' ? 'body1' : 'body2';

  const sellerMaterialComponents = siteMaterial.material_product?.material_component_values
    ? siteMaterial.material_product.material_component_values.filter(
        (materialComponentValue) => materialComponentValue.type === MaterialProductValueType.SELLER
      )
    : [];
  const supplyMaterialComponents = filterMaterialComponentsByCategory<MaterialProductComponentValue>(
    sellerMaterialComponents,
    MaterialComponentCategory.MATERIAL_QUALITY
  );
  const demandMaterialComponents = filterMaterialComponentsByCategory<MaterialComponentValue>(
    demandSignal.material_component_values,
    MaterialComponentCategory.MATERIAL_QUALITY
  );

  const availableQualityData = getAvailableQualityDataForMaterialComponents(quality_data, demandMaterialComponents);

  return (
    <>
      <Stack>
        <MatchedSiteMaterialDetailsSectionTitle title={material_spec.title} type={variant}>
          {site.trade_company.name}
        </MatchedSiteMaterialDetailsSectionTitle>
      </Stack>
      <Stack direction="column" gap={1.5} mb={1.5}>
        <TypographyIcon icon={Inventory2Outlined} variant={textVariant}>
          <Link
            to={`/ground-control/v2/manage-company/${site.trade_company?.id}/site-materials/${id}/update`}
            target="_blank"
          >
            {grade.name} {material_spec.title}
          </Link>
        </TypographyIcon>

        <TypographyIcon variant={textVariant} icon={PublicOutlined}>
          {getCountryNameByCountryAbbr(site.country)}
        </TypographyIcon>

        {material_product ? (
          <Typography textTransform="capitalize" title="Material origin" variant={textVariant}>
            {material_product.material_origin?.type}
          </Typography>
        ) : null}
        <MaterialComponentValueList
          materialComponents={supplyMaterialComponents}
          variant={textVariant}
          title="Target materials"
        />
        <QualityDataList qualityData={availableQualityData} />
      </Stack>
      <QualityReportLink siteMaterialPublicId={public_id} fullWidth={false} size="small" />
    </>
  );
};
